import paletteFigma from './figma/palette';

// palleteNext is a collection of custom and backwards compatible overrides
// already used by the application, but not added to the figma palette.
const paletteNext = {
  alert: {
    dark: '#5F2120',
    light: '#FDEEEF',
    warning: {
      background: '#FFF4E5',
      color: '#663C00',
      icon: '#ED6C02',
    },
  },
  blue: {
    dark: '#0D47A1',
    light: '#90CAF9',
    main: '#2196F3',
  },
  graphic: {
    dark: '#3C4148',
    icons: '#010B1A, 54%',
    light: '#ECECEC',
    lighter: '#F6F6F6',
    main: '#B7BCC5',
  },
  gray: {
    dark: '#607C7B',
    light: '#D1D6D6',
    main: '#90A4A2',
  },
  green: {
    dark: '#1E4620',
    light: '#EDF7ED',
    main: '#22883A',
  },
  hover: {
    main: '#34914A',
  },
  orange: {
    dark: '#EF6C00',
  },
  purple: {
    dark: '#1A237E',
    light: '#9FA8DA',
    main: '#3F51B5',
  },
  secondary: {
    ...paletteFigma.light.secondary,
    hover: '#1a76d214',
  },
  statusChip: {
    default: {
      actionFocus: '#2136571F',
      actionHover: '#213657',
      defaultEnabledBorder: '#B6BCC4',
    },
    error: {
      actionFocus: '#D32F2FB3',
      actionHover: '#D32F2F4D',
      background: '#D32F2F0A',
      disabled: '#D32F2F61',
      main: '#D32F2F',
    },
    info: {
      actionFocus: '#0288D1B3',
      actionHover: '#0288D14D',
      disabled: '#0288D161',
      main: '#0288D1',
    },
    primary: {
      actionFocus: '#22883AB3',
      actionHover: '#22883A4D',
      background: '#22883A14',
      dark: '#01581D',
      disabled: '#9DD2A5',
      main: '#22883A',
    },
    secondary: {
      actionFocus: '#1A77D2B3',
      actionHover: '#1A77D24D',
      disabled: '#2397F361',
      main: '#2397F3',
    },
    success: {
      actionFocus: '#2E7D32B3',
      actionHover: '#2E7D324D',
      disabled: '#22883A61',
      main: '#22883A',
    },
    warning: {
      actionFocus: '#EF6C00B3',
      actionHover: '#EF6C004D',
      background: '#EF6C0014',
      dark: '#E65100',
      disabled: '#EF6C0061',
      main: '#EF6C00',
    },
  },
  surface: {
    alt: '#F8F8F9',
    border: '#E2E4E7',
    light: '#FAFAFA',
    medium: '#F5F5F5',
    mobile: '#F8FAFD',
    swimlane: '#E7E7E7',
    white: '#FFFFFF',
  },
  table: {
    header: '#455163',
  },
  teal: {
    dark: '#004D40',
    light: '#80CBC4',
    main: '#009688',
  },
  text: {
    ...paletteFigma.light.text,
    dark: '#000000',
    link: '#22883A',
  },
  yellow: {
    dark: '#FF8F00',
    light: '#FFE082',
    main: '#FFC107',
  },
};

// The final palette is a combination of the figma palette and the custom overrides in paletteNext.
// The _next key is used to store the combined palette for easy access and future reference.
const palette = {
  _next: { ...paletteFigma.light, ...paletteNext },
  blue: {
    dark: '#0D47A1',
    light: '#90CAF9',
    main: '#2196F3',
  },
  error: {
    contrastText: '#FFFFFF',
    dark: '#B71C1C',
    light: '#FFCDD2',
    main: '#E53935',
  },
  graphic: {
    dark: '#3C4148',
    icons: '#010B1A, 54%',
    light: '#ECECEC',
    lighter: '#F6F6F6',
    main: '#B7BCC5',
  },
  gray: {
    dark: '#607C7B',
    light: '#D1D6D6',
    main: '#90A4A2',
  },
  hover: {
    main: '#34914A',
  },
  orange: {
    dark: '#EF6C00',
  },
  primary: {
    contrastText: '#FFFFFF',
    dark: '#053915',
    light: '#B2D7C3',
    lighter: '#DFEFE7',
    main: '#267E4D',
  },
  purple: {
    dark: '#1A237E',
    light: '#9FA8DA',
    main: '#3F51B5',
  },
  secondary: {
    dark: '#01581D',
    light: '#E6F4E9',
    main: '#22883A',
    medium: '#9DD2A5',
  },
  success: {
    dark: '#0D47A1',
    light: '#BBDEFB',
    lighter: '#E8EEF7',
    main: '#2196F3',
  },
  surface: {
    light: '#FAFAFA',
    medium: '#F5F5F5',
    mobile: '#F8FAFD',
    swimlane: '#E7E7E7',
    white: '#FFFFFF',
  },
  teal: {
    dark: '#004D40',
    light: '#80CBC4',
    main: '#009688',
  },
  text: {
    dark: '#000000',
    disabled: '#A4A4A4',
    link: '#22883A',
    primary: '#213657',
    secondary: '#666666',
  },
  warning: {
    dark: '#F57F17',
    light: '#FFF59D',
    main: '#FDD835',
  },
  yellow: {
    dark: '#FF8F00',
    light: '#FFE082',
    main: '#FFC107',
  },
};

export default palette;
